import { QueryClientProvider } from '@tanstack/react-query';

import { AuditStoreProvider } from '@/contexts/AuditStoreProvider';

import { queryClient } from './config/react-query';

interface AppProvidersProps {
  children: React.ReactNode;
}

export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuditStoreProvider>{children}</AuditStoreProvider>
    </QueryClientProvider>
  );
};
